/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Cancel_FailedInputs */

const vi_carrier_cancel_failed = /** @type {(inputs: Carrier_Cancel_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huỷ vận đơn thất bại`)
};

/**

* @param {Carrier_Cancel_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_cancel_failed = /** @type {((inputs?: Carrier_Cancel_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Cancel_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_cancel_failed(inputs)
});